module.exports = __webpack_public_path__ + "static/gallery12-5f4c098e7fe31f4ff1b75047bc1ec640.jpg";